module.exports = "https://cdn.dove.it/_next/static/public/assets/altroconsumo/hero.cb8bf0e0af7f02f054f4c143b88b312b.jpg";